export async function handleFormChange(value, key, formData, updateFormData) {

    try {

        updateFormData({
            ...formData,
            // Trimming any whitespace
            [key]: value.trim(),
        });

    } catch (err) {



    }

}